import { NgModule } from '@angular/core';
import { ModusSelect } from './modus-select.directive';

@NgModule({
  declarations: [ModusSelect],
  exports: [ModusSelect],
})
export class ModusSelectModule {}
